<!-- Modal/Offcanvas para el Timeline de Versiones -->
<div class="version-timeline-container" *ngIf="isVisible">
  <div class="timeline-backdrop" (click)="close()"></div>
  
  <div class="timeline-panel">
    <!-- Header del Timeline -->
    <div class="timeline-header">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <i class="fas fa-history text-primary me-3"></i>
          <div>
            <h4 class="mb-0 fw-bold text-primary">Historial de Versiones</h4>
            <small class="text-muted" *ngIf="timeline">
              Seguimiento completo de cambios para {{ timeline.code_concept }}
            </small>
          </div>
        </div>
        <button type="button" class="btn-close btn-close-lg" (click)="close()" aria-label="Close"></button>
      </div>
      
      <div class="mt-3" *ngIf="timeline">
        <div class="row">
          <div class="col-md-8">
            <div class="d-flex align-items-center flex-wrap gap-3">
              <div class="timeline-stat">
                <i class="fas fa-tag text-primary me-2"></i>
                <span class="fw-bold">{{ timeline.code_concept }}</span>
              </div>
              <div class="timeline-stat">
                <i class="fas fa-layers text-info me-2"></i>
                <span class="fw-bold">{{ timeline.total_versions }}</span>
                <small class="text-muted ms-1">versiones</small>
              </div>
              <div class="timeline-stat">
                <i class="fas fa-star text-warning me-2"></i>
                <span class="fw-bold">{{ timeline.current_version.name }}</span>
                <small class="text-muted ms-1">(actual)</small>
              </div>
            </div>
          </div>
          <div class="col-md-4 text-end">
            <span class="badge bg-success bg-opacity-15 text-success px-3 py-2">
              <i class="fas fa-check-circle me-2"></i>
              Versión Activa
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading State -->
    <div class="timeline-content" *ngIf="loading">
      <div class="text-center py-5">
        <div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;">
          <span class="visually-hidden">Cargando...</span>
        </div>
        <h6 class="text-muted">Cargando historial de versiones...</h6>
        <p class="text-muted small">Por favor espere un momento</p>
      </div>
    </div>

    <!-- Error State -->
    <div class="timeline-content" *ngIf="error && !loading">
      <div class="alert alert-danger border-danger" role="alert">
        <div class="d-flex align-items-start">
          <i class="fas fa-exclamation-triangle text-danger me-3 mt-1"></i>
          <div class="flex-grow-1">
            <h6 class="alert-heading mb-2">Error al cargar el historial</h6>
            <p class="mb-2">{{ error }}</p>
            <button class="btn btn-outline-danger btn-sm" (click)="fetchVersionHistory()">
              <i class="fas fa-redo me-2"></i>
              Reintentar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Timeline Content -->
    <div class="timeline-content" *ngIf="timeline && !loading && !error">
      <div class="timeline-wrapper">
        
        <!-- Timeline Items -->
        <div class="timeline-item" 
             *ngFor="let entry of timeline.timeline; let i = index; let isLast = last"
             [class.is-current]="entry.is_current">
          
          <!-- Timeline Line -->
          <div class="timeline-line" *ngIf="!isLast"></div>
          
          <!-- Timeline Point -->
          <div class="timeline-point" [ngClass]="'timeline-point-' + getActionTypeColor(entry.action_type)">
            <i [class]="getActionTypeIcon(entry.action_type)"></i>
          </div>
          
          <!-- Timeline Card -->
          <div class="timeline-card" 
               (click)="viewDetails(entry.id)"
               [class.current-version]="entry.is_current">
            
            <!-- Card Header -->
            <div class="timeline-card-header">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <span class="version-badge me-2" [ngClass]="'bg-' + getActionTypeColor(entry.action_type)">
                    <i class="fas fa-code-branch me-1"></i>
                    v{{ entry.version_number }}
                  </span>
                  <span class="action-badge ms-1" [ngClass]="'badge bg-' + getActionTypeColor(entry.action_type) + ' bg-opacity-15 text-' + getActionTypeColor(entry.action_type)">
                    <i [class]="getActionTypeIcon(entry.action_type) + ' me-1'"></i>
                    {{ getActionTypeText(entry.action_type) }}
                  </span>
                  <span class="badge bg-primary bg-opacity-15 text-primary ms-2" *ngIf="entry.is_current">
                    <i class="fas fa-star me-1"></i>
                    Versión Actual
                  </span>
                </div>
                <div class="timeline-date">
                  <i class="fas fa-clock me-1"></i>
                  {{ formatDate(entry.action_date) }}
                </div>
              </div>
            </div>

            <!-- Card Body -->
            <div class="timeline-card-body">
              <div class="version-title-section mb-3">
                <h5 class="version-title mb-1">{{ entry.name }}</h5>
                <p class="version-description text-muted mb-0">{{ entry.description }}</p>
              </div>
              
              <!-- Configuration Preview -->
              <div class="config-preview">
                <div class="config-grid">
                  <div class="config-item">
                    <div class="config-label">
                      <i class="fas fa-cogs text-primary me-1"></i>
                      Tipo de Aplicación
                    </div>
                    <div class="config-value">{{ entry.fee_config.application_type.name }}</div>
                  </div>
                  
                  <div class="config-item">
                    <div class="config-label">
                      <i class="fas fa-calendar-alt text-info me-1"></i>
                      Frecuencia
                    </div>
                    <div class="config-value">{{ entry.fee_config.frequency.name }}</div>
                  </div>
                  
                  <div class="config-item">
                    <div class="config-label">
                      <i class="fas fa-ruler text-warning me-1"></i>
                      Unidad de Medida
                    </div>
                    <div class="config-value">{{ entry.fee_config.unit_of_measure }}</div>
                  </div>
                  
                  <div class="config-item">
                    <div class="config-label">
                      <i class="fas fa-hashtag text-success me-1"></i>
                      Límite
                    </div>
                    <div class="config-value">{{ entry.fee_config.limit }}</div>
                  </div>
                </div>
              </div>

              <!-- Status and Rules Summary -->
              <div class="summary-section mt-3">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="status-badges">
                    <span class="badge me-2" 
                          [ngClass]="{'bg-success bg-opacity-15 text-success': entry.status, 'bg-danger bg-opacity-15 text-danger': !entry.status}">
                      <i class="fas fa-circle me-1"></i>
                      {{ entry.status ? 'Activo' : 'Inactivo' }}
                    </span>
                    <span class="badge bg-secondary bg-opacity-15 text-secondary" *ngIf="entry.paused">
                      <i class="fas fa-pause me-1"></i>
                      Pausado
                    </span>
                  </div>
                  <div class="rules-summary">
                    <span class="badge bg-info bg-opacity-15 text-info">
                      <i class="fas fa-list me-1"></i>
                      {{ entry.fees_count }} regla{{ entry.fees_count !== 1 ? 's' : '' }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- User Information -->
              <div class="user-section mt-3">
                <div class="d-flex align-items-center">
                  <div class="user-avatar me-3">
                    {{ getUserInitials(entry.action_user.name) }}
                  </div>
                  <div class="user-details flex-grow-1">
                    <div class="user-name">{{ entry.action_user.name }}</div>
                    <div class="user-email">{{ entry.action_user.email }}</div>
                  </div>
                </div>
                
                <!-- Observation -->
                <div class="observation-section mt-2" *ngIf="entry.observation">
                  <div class="observation-card">
                    <i class="fas fa-comment text-info me-2"></i>
                    <span class="text-muted">{{ entry.observation }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Click to view details indicator -->
            <div class="view-details-indicator">
              <div class="d-flex align-items-center justify-content-center">
                <i class="fas fa-eye me-2"></i>
                <span>Click para ver configuración completa</span>
                <i class="fas fa-arrow-right ms-2"></i>
              </div>
            </div>
          </div>
        </div>

        <!-- Empty State -->
        <div class="empty-timeline" *ngIf="timeline.timeline.length === 0">
          <div class="text-center py-5">
            <div class="empty-icon mb-3">
              <i class="fas fa-history"></i>
            </div>
            <h5 class="text-muted mb-2">No hay historial disponible</h5>
            <p class="text-muted">Este concepto no tiene versiones registradas en el sistema.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="timeline-footer">
      <div class="d-flex justify-content-between align-items-center">
        <div class="footer-info">
          <i class="fas fa-info-circle text-primary me-2"></i>
          <span class="text-muted">Click en cualquier versión para ver su configuración completa</span>
        </div>
        <button type="button" class="btn btn-secondary" (click)="close()">
          <i class="fas fa-times me-2"></i>
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div> 